/**
 * Error boundary specifically for location-related routes.
 * Catches 404 errors and displays a proper not found page instead of generic error messages.
 */
import { EntityNotFound } from '@/components/entity-not-found';
import axios from 'axios';
import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

export function LocationErrorBoundary(props: PropsWithChildren) {
  const handleError = (error: Error) => {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return (
        <EntityNotFound
          entityType="location"
          listPath="/locations"
          listLabel="Go to locations"
        />
      );
    }

    throw error;
  };

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => handleError(error)}
      onError={(error) => {
        if (!axios.isAxiosError(error) || error.response?.status !== 404) {
          throw error;
        }
      }}
    >
      {props.children}
    </ErrorBoundary>
  );
}
